import React from "react";
import RootLayout from "./RootLayout";
import {
  DownOutlined,
  LogoutOutlined,
  MenuOutlined,
  UserOutlined
} from "@ant-design/icons";
import { Col, Dropdown, Layout, Menu, Row } from "antd";
import { TTranslate } from "../../service/locale/TranslationService";
import { TPresentable } from "../../presenter/withStore";
import Link from "../components/Link";
import { IUser } from "../../../user/model/User";
import logo from "../assets/images/logo-new.png";
import eu_logo from "../../../core/ui/assets/images/eu-emblem.jpg";
import aire_logo from "../../../core/ui/assets/images/aire-logo.png";
import AdminLayoutMenu from "../components/AdminLayoutMenu";
import OrganisationOperatorLayoutMenu from "../components/OrganisationOperatorLayoutMenu";
import { ILanguage } from "../../model/language/Language";
import ChangeLanguageInteractor from "../../interactor/language/ChangeLanguageInteractor";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import { IOrganisation } from "../../../organisations/model/Organisation";
import Application from "../../../Application";
import Text from "antd/lib/typography/Text";
import Title from "antd/lib/typography/Title";
import LanguageSelectionList from "../components/LanguageSelectionList";
import { Footer } from "antd/lib/layout/layout";
import LayoutFooter from "../../../portal/ui/layouts/LayoutFooter";

const { Header, Content } = Layout;
const { SubMenu } = Menu;

export interface Props {
  router: any;
  children?: any;
  translate: TTranslate;
  style?: any;
  params?: any;
}
export interface State extends TPresentable {
  collapsed: boolean;
}

export default class AppLayout extends React.Component<Props, State> {
  private subscriptionId: number = 0;
  constructor(props) {
    super(props);
    this.state = { ...props, collapsed: true };
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { children, translate, router } = this.props;
    const {
      userOrganisation: organisation,
      user,
      languages,
      application,
      selectedLanguage
    }: {
      userOrganisation: IOrganisation;
      user: IUser;
      languages: ILanguage[];
      application: Application;
      selectedLanguage: ILanguage;
    } = this.state as any;
    // const onRenderBreadcrumbLabel = (this.state.store.getState() as any)
    //   .breadCrumb;
    const redirect = (path) => {
      router.push({
        pathname: path
      });
    };
    // const { collapsed } = this.state;

    const userMenu = (
      <Menu mode="horizontal" overflowedIndicator={<MenuOutlined />}>
        <Menu key="user-submenu">
          <Menu.Item
            key="setting:change-password"
            onClick={() => redirect("/change-password")}
          >
            <span>
              <i className="fa fa-key" aria-hidden="true" />
              {`  ${translate("menu.change_password")}`}
            </span>
          </Menu.Item>
          <Menu.Item key="setting:logout" onClick={() => redirect("/dologout")}>
            <span>
              <LogoutOutlined />
              {`  ${translate("menu.logout")}`}
            </span>
          </Menu.Item>
        </Menu>
      </Menu>
    );

    const changeLanguage = async (language: ILanguage) => {
      try {
        await application.container
          .resolve<ChangeLanguageInteractor>("changeLanguage")
          .execute(language.code, false);
        let newLanguageNameCode = language.code;
        application.changeSystemLanguage(newLanguageNameCode);
        window.location.reload();
      } catch (error: any) {
        application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute(error.message);
      }
    };
    const renderUserMenuItems = () => {
      if (user?.isAdmin() || user?.isSuperAdmin()) {
        return <AdminLayoutMenu translate={translate} router={router} />;
      } else if (user?.isOperator()) {
        return (
          <OrganisationOperatorLayoutMenu
            translate={translate}
            router={router}
            userOrganisation={organisation}
          />
        );
      } else {
        return <></>;
      }
    };
    return (
      <RootLayout {...this.props}>
        <Layout className={"layout-main-wrapper"}>
          <Layout className={"layout-content-wrapper"}>
            <Header className="portal-layout-header">
              <Row className="w-100 h-100">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={13}
                  xl={16}
                  xxl={17}
                  className=" vertical-align-middle"
                >
                  <div className="display-flex flex-direction-column flex-direction-md-row vertical-align-middle">
                    <Link router={router} path="/">
                      <img
                        src={logo}
                        alt="Logo"
                        style={{
                          height: "65px"
                        }}
                      />
                    </Link>
                    <div
                      className="display-flex flex-direction-column"
                      style={{ marginLeft: 12 }}
                    >
                      <Title
                        level={1}
                        className="text-align-center text-align-md-left"
                        style={{
                          color: "white",
                          fontSize: 27,
                          marginTop: 0,
                          marginBottom: 0,
                          lineHeight: 1
                        }}
                      >
                        {organisation
                          ? organisation.name
                          : translate("app.portal")}
                      </Title>
                      <Text
                        style={{
                          color: "white",
                          fontWeight: 400,
                          fontSize: 20,
                          lineHeight: 1,
                          marginBottom: 6
                        }}
                        className="text-align-center text-align-md-left"
                      >
                        {organisation ? translate("app.title") : ""}
                      </Text>
                    </div>
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={11}
                  xl={8}
                  xxl={7}
                  className="display-flex align-center align-md-right vertical-align-top mt-1 mt-md-0 no-print"
                >
                  <LanguageSelectionList
                    onChangeLanguage={changeLanguage}
                    languages={languages}
                    selectedLanguage={selectedLanguage}
                  />
                  <Dropdown overlay={userMenu} className="vertical-align-top">
                    <a
                      onClick={(e) => e.preventDefault()}
                      style={{ color: "white" }}
                    >
                      <span
                        className="vertical-align-top"
                        style={{ lineHeight: "20px", padding: "0 8px" }}
                      >
                        |
                      </span>
                      <UserOutlined
                        className={"header-menu-item-icon"}
                        style={{ margin: "3px 0 0 0", padding: "0 4px" }}
                      />
                      <span
                        style={{ lineHeight: "24px", padding: "0 4px" }}
                        className={
                          "header-menu-item-label header-menu-primary-item-lg-label vertical-align-top"
                        }
                      >
                        <strong>{user?.username}</strong>
                      </span>
                    </a>
                  </Dropdown>
                </Col>
              </Row>
            </Header>

            <Header className="portal-layout-subheader">
              <Row align="middle" className={"align-center"}>
                <Col lg={24} md={4} sm={4} xs={4}>
                  {renderUserMenuItems()}
                </Col>
              </Row>
            </Header>
            <Content
              className={"layout-content-container"}
              style={Object.assign({}, {}, this.props.style || {})}
            >
              <div className={"layout-content-container-children"}>
                {children}
              </div>
              <LayoutFooter translate={translate} />
            </Content>
          </Layout>
        </Layout>
      </RootLayout>
    );
  }
}
